/* eslint-disable max-len */
const Telegram = () => (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C17.524 22 22 17.524 22 12C22 6.476 17.524 2 12 2C6.476 2 2 6.476 2 12C2 17.524 6.476 22 12 22ZM6.576 11.783L16.218 8.066C16.665 7.904 17.056 8.175 16.911 8.852V8.85L15.27 16.584C15.148 17.132 14.823 17.266 14.367 17.007L11.867 15.165L10.661 16.327C10.528 16.46 10.415 16.572 10.157 16.572L10.334 14.028L14.967 9.842C15.169 9.665 14.922 9.565 14.657 9.742L8.93 13.346L6.462 12.576C5.926 12.406 5.914 12.041 6.575 11.782L6.576 11.783Z" fill="white" />
  </svg>
);

export default Telegram;
